'use client'
import { useState } from 'react';
import { UserDefaultIcon} from '@practium/ui';
import styles from './Avatar.module.css';

interface AvatarProps {
	src?: string;
	alt: string;
	onClick?: () => void;
}

export const Avatar = ({ src, alt, onClick }: AvatarProps) => {
	const [imageError, setImageError] = useState(false);

	const handleImageError = () => {
		setImageError(true);
	};

	return (
		<button className={styles.avatar} onClick={onClick} aria-label="Menu do usuário">
			{src && !imageError ? (
				<img src={src} alt={alt} className={styles.avatarImage} onError={handleImageError} />
			) : (
				<UserDefaultIcon className={styles.avatarIcon} />
			)}
		</button>
	);
};
